import Builder from './components/Builder'
import apiFetch from "@wordpress/api-fetch";

document.addEventListener("DOMContentLoaded", DOMContentLoadedImport);

function DOMContentLoadedImport() {


    var appData = {
        name: "Testimonial",
        version: "1.0.0",
        demoUrl: "https://pickplugins.com/demo/testimonial/",
        reviewsUrl: "https://wordpress.org/support/plugin/testimonial/reviews/#new-post/"
    }

    window.testimonial = {};
    window.testimonial = appData;

    apiFetch({
        path: "/testimonial/v2/get_options",
        method: "POST",
        data: { option: "testimonial_settings" },
    }).then((res) => {
        if (res.length != 0) {
            var resX = { ...res };
            var license_key = resX?.license_key;


            window.testimonial = { ...appData, license_key: license_key };


        }
    });

    // console.log(window.testimonial)

    setTimeout(() => {

        var builderWrap = document.querySelector('#builder');


        if (builderWrap != null) {
            wp.element.render(<Builder appData={appData} />, builderWrap)
        }
    }, 2000)



}



